export const ADD_USER_TAG_OPTION = 'ADD_USER_TAG_OPTION'
export const ADD_USER_TAG_OPTION_TRANSLATION = 'ADD_USER_TAG_OPTION_TRANSLATION'
export const SET_USER_TAG_OPTIONS_PROCESSING = 'SET_TAGS_PROCESSING'
export const GET_USER_TAG_OPTIONS = 'GET_USER_TAG_OPTIONS'
export const SET_NEW_USER_TAG_OPTION = 'SET_NEW_USER_TAG_OPTION'
export const SET_NEW_USER_TAG_OPTION_TRANSLATION = 'SET_NEW_USER_TAG_OPTION_TRANSLATION'
export const SET_USER_TAG_OPTIONS = 'SET_USER_TAG_OPTIONS'
export const SET_USER_TAG_OPTIONS_ERROR = 'SET_USER_TAG_OPTIONS_ERROR'
export const UPDATE_USER_TAG_OPTION = 'UPDATE_USER_TAG_OPTION'
export const UPDATE_USER_TAG_TRANSLATION = 'UPDATE_USER_TAG_TRANSLATION'
export const DELETE_USER_TAG_OPTION = 'DELETE_USER_TAG_OPTION'
export const DELETE_USER_TAG_TRANSLATION = 'DELETE_USER_TAG_TRANSLATION'
export const REMOVE_USER_TAG_OPTION = 'REMOVE_USER_TAG_OPTION'

export function addUserTagOption (data) {
  return {
    type: ADD_USER_TAG_OPTION,
    payload: data,
  }
}

export function addUserTagOptionTranslation (data) {
  return {
    type: ADD_USER_TAG_OPTION_TRANSLATION,
    payload: data,
  }
}

export function deleteUserTagOption (data) {
  return {
    type: DELETE_USER_TAG_OPTION,
    payload: data,
  }
}

export function deleteUserTagTranslation (data) {
  return {
    type: DELETE_USER_TAG_TRANSLATION,
    payload: data,
  }
}

export function removeUserTagOption (data) {
  return {
    type: REMOVE_USER_TAG_OPTION,
    payload: data,
  }
}

export function setNewUserTagOption (data) {
  return {
    type: SET_NEW_USER_TAG_OPTION,
    payload: data,
  }
}
export function setNewUserTagOptionTranslation (data) {
  return {
    type: SET_NEW_USER_TAG_OPTION_TRANSLATION,
    payload: data,
  }
}

export function getUserTagOptions () {
  return {
    type: GET_USER_TAG_OPTIONS,
  }
}

export function updateUserTagOption (data) {
  return {
    type: UPDATE_USER_TAG_OPTION,
    payload: data,
  }
}

export function updateUserTagTranslation (data) {
  return {
    type: UPDATE_USER_TAG_TRANSLATION,
    payload: data,
  }
}

export function setUserTagOptionsProcessing ({ data }) {
  return {
    type: SET_USER_TAG_OPTIONS_PROCESSING,
    payload: data,
  }
}

export function setUserTagOptions (data) {
  return {
    type: SET_USER_TAG_OPTIONS,
    payload: data,
  }
}

export function setUserTagOptionsError (data) {
  return {
    type: SET_USER_TAG_OPTIONS_ERROR,
    payload: data,
  }
}
